/**
 * Password Toggle Functionality
 * Adds show/hide password feature to all password inputs
 * 
 * @author MC-Project
 * @version 1.0.0
 */

class PasswordToggle {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.attachToggles());
    } else {
      this.attachToggles();
    }

    // Re-attach when sections reload (Shopify theme editor)
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => this.attachToggles());
    }
  }

  attachToggles() {
    // Find all password toggle buttons
    const toggleButtons = document.querySelectorAll('.password-toggle-button');
    
    toggleButtons.forEach(button => {
      // Check if already processed
      if (button.hasAttribute('data-toggle-attached')) return;
      
      button.setAttribute('data-toggle-attached', 'true');
      
      // Find the password input (sibling)
      const formControl = button.closest('.form-control');
      if (!formControl) return;
      
      const passwordInput = formControl.querySelector('input[type="password"], input[type="text"]');
      if (!passwordInput) return;
      
      // Attach click listener
      button.addEventListener('click', () => {
        this.togglePassword(passwordInput, button);
      });
      
      console.log('✅ Password toggle attached:', passwordInput.name);
    });
  }

  togglePassword(input, button) {
    // Toggle input type
    const isPassword = input.type === 'password';
    input.type = isPassword ? 'text' : 'password';
    
    // Toggle button state
    button.classList.toggle('show-password', isPassword);
    
    // Update aria-label
    const label = isPassword ? 'Hide password' : 'Show password';
    button.setAttribute('aria-label', label);
    
    // Optional: Focus back to input
    input.focus();
  }
}

// Initialize
new PasswordToggle();
